import mitt from 'mitt'

type ApplicationEvents = {
  'popper:event': { type: 'close' | 'next' | 'finish' }
  'cart:add-product': void
  // Event to load categories in ecommerce home when switching areas but same restaurant
  'ecommerce:home:load-categories': void
}

const emitter = mitt<ApplicationEvents>()

export const useEvent = emitter.emit
export const useListen = emitter.on
export const useStopListen = emitter.off
